<template>
    <div class=" page">
        <div class=" content">
            <img src="../../../assets/icon/ic-error.svg"/>
            <div class="error-text" v-html="message"></div>
            <div @click="clickBack()" class="bt-back">Back</div>
        </div>
    </div>
</template>

<script>
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/Locale.js";
import LocaleMixin from '@/mixin/LocaleMixin.js';
export default {
    name: 'ErrorPage',
    mixins: [LocaleMixin],
    data: function() {
        return {
            lbl: Locale.getLbl(),
            message: '',
        }
    },
    created: function() {
        this.query = Account.getCacheQuery("DealShop")
        console.log(this.query)
        this.errorCode = this.$route.query.code
        console.log(this.errorCode)
        this.errorMessage()
    },
    methods: {
        errorMessage: function() {
            switch(this.errorCode){
                case "412":
                    this.message = this.lbl.error_code.code_412
                    break;
                case "campaignId":
                    this.message = this.lbl.error_code.code_campaignId
                    break;
                case "cat_id":
                    this.message = this.lbl.error_code.code_cat_id
                    break;
                case "agency_id":
                    this.message = this.lbl.error_code.code_agency_id
                    break;
                case "target_page":
                    this.message = this.lbl.error_code.code_target_page
                    break;
                default:
                    this.message = 'Connection Failed'
            }
        },
        clickBack: function () {
            if (this.query.target_page) {
                window.location.replace(this.query.returnUrl);
            } else {
                this.$router.back();
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .page {
        background-color: #e9e9e9;
        min-height: 100vh;
        margin: auto auto;
        display: flex;
        flex: 1;
        .content{
            margin: auto auto;
            img{
                display: flex;
                width: 84px;
                margin: auto auto;
            }
            .error-text{
                color: #373737;
                font-size: 16px;
                font-family: $ff-reg;
                padding: 20px 0px;
                margin: auto auto;
            }
            .bt-back{
                text-align: center;
                font-size: 16px;
                font-family: $ff-bold;
                color: #333333;
                padding: 4px;
                border: solid 1px #333333;
                border-radius: 8px;

            }
        }
    }
</style>
